import { Form, Select } from 'antd'
import SendButton from './SendButton'
import SendImage from "./SendImages";
import SendAudio from "./SendAudio";
import SendText from "./SendText";
import TransferAssistant from "./TransferAssistant";
import SendList from "./SendList";
import SendFile from "./SendFiles";

const actions = [
  {
    label: 'Enviar Botões',
    value: 'SEND_BUTTON',
  },
  {
    label: 'Enviar Lista',
    value: 'SEND_LIST',
  },
  {
    label: 'Enviar Imagens',
    value: 'SEND_IMAGE',
  },
  {
    label: 'Enviar Audios',
    value: 'SEND_AUDIO',
  },
  {
    label: 'Enviar Textos',
    value: 'SEND_TEXT',
  },
  {
    label: 'Enviar Arquivos',
    value: 'SEND_FILE',
  },
  {
    label: 'Transferir p/ Assistente',
    value: 'TRANSFER_ASSISTANT',
  },
]

export default function NativeForm({
  form,
  parameters,
  fieldName,
}) {
  const type = Form.useWatch(['actions', fieldName, 'action', 'type'], form)

  return (
    <>
      <Form.Item label={'Tipo de ação'} name={[fieldName, 'action', 'type']}>
        <Select options={actions} placeholder={'Selecione o tipo de ação'} />
      </Form.Item>
      {type === 'SEND_BUTTON' && (
        <SendButton
          form={form}
          fieldName={fieldName}
          parameters={parameters}
        />
      )}
      {type === 'SEND_LIST' && (
        <SendList
          form={form}
          fieldName={fieldName}
          parameters={parameters}
        />
      )}
      {type === 'SEND_IMAGE' && (
        <SendImage
          form={form}
          fieldName={fieldName}
          parameters={parameters}
        />
      )}
      {type === 'SEND_AUDIO' && (
        <SendAudio
          fieldName={fieldName}
        />
      )}
      {type === 'SEND_TEXT' && (
        <SendText
          fieldName={fieldName}
        />
      )}
      {type === 'SEND_FILE' && (
        <SendFile
          form={form}
          fieldName={fieldName}
          parameters={parameters}
        />
      )}
      {type === 'TRANSFER_ASSISTANT' && (
        <TransferAssistant
          fieldName={fieldName}
        />
      )}
    </>
  )
}
